import React, { useState, useRef, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Tooltip from '../addentities/Tooltip';
import { Check, CircleCheck, CloudUpload, Info, ListChecks, X } from 'lucide-react';

export default function BulkImport() {
    const history = useHistory();
    const breadcrumbs = ["Settings", "SKU Presets", "Bulk Import"];
    const [showItemAlert, setShowItemAlert] = useState(false);
    const [uploadedImage, setUploadedImage] = useState(null);
    const [isDragging, setIsDragging] = useState(false);
    const fileInputRef = useRef(null);
    const handleSave = async () => {
        setShowItemAlert(true);
        setTimeout(() => {
            setShowItemAlert(false);
        }, 3000);
    };
    const [formData, setFormData] = useState({
        uuid: '',
        brand_name: '',
        prefix: '',
        parent_id: '',
        original_logo: null,
        status: '0',
        notes: '',
    });

    useEffect(() => {
        setFormData((prevFormData) => ({
            ...prevFormData,
            original_logo: uploadedImage
        }));
    }, [uploadedImage]);

    const handleDiscard = () => {
        history.goBack();
    };

    const handleDragEnter = (e) => {
        e.preventDefault();
        setIsDragging(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        setIsDragging(false);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleBrowseClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const [uploadedFile, setUploadedFile] = useState(null);
    const [step, setStep] = useState(1);
    const [uploadLineFilled, setUploadLineFilled] = useState(false);
    const [checkLineFilled, setCheckLineFilled] = useState(false);
    const [uploadError, setUploadError] = useState(null);



    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        setUploadError(null); // reset error
        if (!file) return;

        // Step 1 → 2: Begin upload to check
        setStep(1);
        setUploadLineFilled(false);
        setCheckLineFilled(false);

        setTimeout(() => {
            setUploadLineFilled(true); // animate Upload → Check line
            setTimeout(() => {
                setStep(2); // now move to Check
                const isValid = /\.(xls|xlsx|csv)$/i.test(file.name);

                if (!isValid) {
                    setUploadError("Only .xls, .xlsx and .csv files are supported.");
                    return;
                }

                setUploadedFile(file);
                setTimeout(() => {
                    setCheckLineFilled(true); // animate Check → Complete
                    setTimeout(() => {
                        setStep(3); // go to complete only after valid file
                    }, 500); // time after line fill
                }, 1000); // simulate check delay
            }, 1000); // after upload line animation
        }, 300); // slight delay before animation starts
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setIsDragging(false);
        const file = e.dataTransfer.files[0];
        if (file && /\.(xls|xlsx|csv)$/i.test(file.name)) {
            setUploadedFile(file);
            setStep(2);
            setTimeout(() => setStep(3), 1000);
        } else {
            alert("Invalid file type.");
        }
    };

    const handleRemoveFile = () => {
        setUploadedFile(null);
        setStep(1);
        setUploadLineFilled(false);
        setCheckLineFilled(false);
        setUploadError(null);
        if (fileInputRef.current) fileInputRef.current.value = null;
    };

    const handleDownloadTemplate = () => {
        window.open('/templates/file_example_XLS_5000.xls', '_blank'); // No need for full URL
    };

    return (
        <div className="company-body main-company-body-inner new-look">
            <div className="breadcrumb">
                {breadcrumbs.map((crumb, index) => {
                    const isLast = index === breadcrumbs.length - 1;
                    return (
                        <span
                            key={index}
                            className={`breadcrumb-item ${crumb === "SKU Presets" ? "clickable" : ""}`}
                            onClick={() => {
                                if (crumb === "SKU Presets") {
                                    history.push("/sku-presets");
                                }
                            }}
                            style={{ cursor: crumb === "SKU Presets" ? "pointer" : "default" }}
                        >
                            {crumb}
                            {!isLast ? "  " : ""}
                        </span>
                    );
                })}
            </div>
            <div className='edit-organisation-info'>
                <div className='edit-organisation-left'>
                    <h1>Bulk Import <Tooltip content="Bulk Import">
                        <Info size={16} className="info-icon" />
                    </Tooltip></h1>
                </div>
                <div className='discard-save-organisation-right d-flex align-items-center gap-2'>
                    <button
                        className="dark-button"
                        type='button'
                        onClick={handleDiscard}
                    >
                        Cancel
                    </button>
                    <button
                        className="dark-border"
                        type='button'
                    onClick={handleSave}
                    >
                        Request
                    </button>
                </div>
            </div>
            {showItemAlert && (
                <div
                    className="d-flex align-items-center justify-content-between"
                    role="alert"
                    style={{
                        boxShadow: "0px 4px 10px 0px #0000001F",
                        padding: "15px 10px",
                        borderRadius: "12px",
                        border: "1px solid #30B473",
                        backgroundColor: "#E6F7EF",
                        color: "#0D6438",
                        fontSize: "12px",
                        position: "fixed",
                        top: "10px",
                        width: "calc(100% - 20px)",
                        maxWidth: "640px",
                        left: "50%",
                        transform: "translateX(-50%)",
                        zIndex: 2000,
                    }}
                >
                    <div className="d-flex align-items-center">
                        <CircleCheck className="me-2" />
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                            }}
                        >
                            <strong>Bulk imported successfully</strong>
                        </div>
                    </div>

                    <X
                        size={16}
                        style={{ cursor: "pointer" }}
                        onClick={() => setShowItemAlert(false)}
                    />
                </div>
            )}
            <div className="info-section">
                <div class="info-card new-info-overflow-auto">
                    <div className="info-content d-block">
                        <div className='grid-info-adding'>
                            {/* <div className='row gappingcls-added'>
                                <div className='col-12'>

                                </div>
                            </div> */}
                            <div className='row gappingcls-added'>
                                {/* Upload a Spreadsheet for import COLUMN */}
                                <div className='col-12'>
                                    <div className="info-inner bulk-upload-wrapper">

                                        <div className="step-progress">
                                            <div className={`step ${step >= 1 ? 'active' : ''}`}>
                                                <div className="step-icon upload">
                                                    <CloudUpload size={18} />
                                                </div>
                                                <span>Upload</span>
                                            </div>
                                            <div className={`step-line ${uploadLineFilled ? 'filled' : ''}`}></div>

                                            <div className={`step ${step >= 2 ? 'active' : ''}`}>
                                                <div className="step-icon check">
                                                    <ListChecks size={18} />
                                                </div>
                                                <span>Check</span>
                                            </div>
                                            <div className={`step-line ${checkLineFilled ? 'filled' : ''}`}></div>

                                            <div className={`step ${step === 3 ? 'active' : ''}`}>
                                                <div className="step-icon complete">
                                                    <Check size={18} />
                                                </div>
                                                <span>Complete</span>
                                            </div>
                                        </div>


                                        <div className="d-flex align-items-center justify-content-between gap-1 flex-wrap edit-organisation-info p-0 shadow-none rounded-0">
                                            <label className="form-label d-flex align-items-center gap-2 m-0">
                                                Upload a Spreadsheet for import
                                                <Tooltip content="Only .xls, .xlsx and .csv files are supported.">
                                                    <Info size={16} className="info-icon" />
                                                </Tooltip>
                                            </label>
                                            <button
                                                className="dark-button"
                                                type='button'
                                                onClick={handleDownloadTemplate}
                                            >
                                                Download Template
                                            </button>
                                        </div>
                                        <div
                                            className={`upload-dropzone ${isDragging ? 'dragging' : ''}`}
                                            onClick={handleBrowseClick}
                                            onDragOver={handleDragOver}
                                            onDragEnter={handleDragEnter}
                                            onDragLeave={handleDragLeave}
                                            onDrop={handleDrop}
                                        >
                                            <input
                                                type="file"
                                                accept=".xls,.xlsx,.csv"
                                                ref={fileInputRef}
                                                style={{ display: 'none' }}
                                                onChange={handleFileUpload}
                                            />
                                            {uploadedFile ? (
                                                <div className="file-preview">
                                                    <span>{uploadedFile.name}</span>
                                                    <button className="remove-btn" onClick={handleRemoveFile}>×</button>
                                                </div>
                                            ) : (
                                                <div className="upload-placeholder">
                                                    <CloudUpload />
                                                    <p>Drag your file here or <span className="browse-text">Browse</span></p>
                                                </div>
                                            )}
                                        </div>
                                        {uploadError && (
                                            <p className="text-danger mt-2">{uploadError}</p>
                                        )}

                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}
